import React from 'react'
import { Link } from 'react-router-dom'
import "./style/Footer.css"

export default function Footer() {
    return (
        <div className='footer'>
            <button>
                <Link to="/order">Orders</Link>
            </button>
            <button>
                <Link to="/">Home</Link>
            </button>
            <button>
                <Link to="/profile">Profile</Link>
            </button>
        </div>
    )
}